// src/components/PageTutorialOverlay.jsx
import React, { useContext, useEffect, useState } from "react";
import Joyride, { STATUS } from "react-joyride";
import { useLocation } from "react-router-dom";
import KeycloakContext from "../../keycloakContext";
import { useTranslation } from "react-i18next";

const TUTORIAL_KEY = "tutorial_app_done";

export default function PageTutorialOverlay() {
  const { t } = useTranslation();
  const keycloak = useContext(KeycloakContext);
  const location = useLocation();
  const [run, setRun] = useState(false);

  useEffect(() => {
    const groups = keycloak?.tokenParsed?.groups || [];
    const isProfessor = groups.includes("/professor");
    if (
      keycloak?.authenticated &&
      !isProfessor &&
      !localStorage.getItem(TUTORIAL_KEY) &&
      !location.pathname.startsWith("/applicatiu")
    ) {
      setRun(true);
    }
  }, [keycloak, location.pathname]);

  function handleCallback({ status }) {
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      localStorage.setItem(TUTORIAL_KEY, "true");
      setRun(false);
    }
  }

  const steps = [
    {
      target: ".navbar",
      title: t("tutorialOverlay.navbarTitle"),
      content: t("tutorialOverlay.navbarContent"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".navbarright",
      title: t("tutorialOverlay.profileTitle"),
      content: t("tutorialOverlay.profileContent"),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".hero-section",
      title: t("tutorialOverlay.welcomeTitle"),
      content: t("tutorialOverlay.welcomeContent"),
      placement: "bottom",
      disableBeacon: true,
    }
  ];


  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showSkipButton
      disableScrolling
      callback={handleCallback}
      spotlightClicks
      styles={{
        options: {
          zIndex: 9999,
          overlayColor: "transparent",
          spotlightPadding: 5,
        },
        spotlight: {
          backgroundColor: "transparent",
          boxShadow: "0 0 0 9999px rgba(0,0,0,0.6)",
        },
      }}
    />
  );
}
